import React from 'react';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <div className="bg-white">
      {/* Hero section */}
      <div className="relative bg-gray-50 overflow-hidden">
        <div className="relative pt-16 pb-12 sm:pb-16 md:pb-20 lg:pb-28 xl:pb-32">
          <div className="mt-10 mx-auto max-w-7xl px-4 sm:px-6">
            <div className="text-center">
              <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
                <span className="block">Über</span>
                <span className="block text-primary-600">NaturalMe</span>
              </h1>
              <p className="mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
                Wir machen natürliche Schönheit sichtbar und helfen Menschen, ihr wahres Aussehen zu entdecken und zu schätzen.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Mission section */}
      <div className="relative py-16 bg-white overflow-hidden">
        <div className="hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full">
          <div className="relative h-full text-lg max-w-prose mx-auto" aria-hidden="true">
            <svg
              className="absolute top-12 left-full transform translate-x-32"
              width={404}
              height={384}
              fill="none"
              viewBox="0 0 404 384"
            >
              <defs>
                <pattern
                  id="74b3fd99-0a6f-4271-bef2-e80eeafdf357"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect x={0} y={0} width={4} height={4} className="text-primary-200" fill="currentColor" />
                </pattern>
              </defs>
              <rect width={404} height={384} fill="url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)" />
            </svg>
            <svg
              className="absolute top-1/2 right-full transform -translate-y-1/2 -translate-x-32"
              width={404}
              height={384}
              fill="none"
              viewBox="0 0 404 384"
            >
              <defs>
                <pattern
                  id="f210dbf6-a58d-4871-961e-36d5016a0f49"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect x={0} y={0} width={4} height={4} className="text-primary-200" fill="currentColor" />
                </pattern>
              </defs>
              <rect width={404} height={384} fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)" />
            </svg>
          </div>
        </div>
        <div className="relative px-4 sm:px-6 lg:px-8">
          <div className="text-lg max-w-prose mx-auto">
            <h2>
              <span className="block text-base text-center text-primary-600 font-semibold tracking-wide uppercase">
                Unsere Mission
              </span>
              <span className="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                Natürliche Schönheit neu definieren
              </span>
            </h2>
            <p className="mt-8 text-xl text-gray-500 leading-8">
              In einer Welt, die von perfektionierten Bildern und unrealistischen Schönheitsstandards geprägt ist, 
              möchten wir einen Gegenpol schaffen. NaturalMe wurde mit einer klaren Vision gegründet: 
              Menschen zu helfen, ihr natürliches Aussehen zu schätzen und zu feiern.
            </p>
          </div>
          <div className="mt-6 prose prose-indigo prose-lg text-gray-500 mx-auto">
            <p>
              Unsere KI-Technologie wurde entwickelt, um eine einzigartige Perspektive zu bieten – einen Blick unter 
              die Schichten von Make-up, um das authentische Gesicht darunter zu enthüllen. Wir glauben, dass jedes 
              Gesicht seine eigene natürliche Schönheit besitzt, die es wert ist, gesehen und geschätzt zu werden.
            </p>
            <p>
              Diese Technologie soll nicht dazu dienen, Make-up zu verurteilen oder abzuwerten. Vielmehr möchten wir 
              ein Werkzeug anbieten, das Neugier weckt, Selbstreflexion fördert und möglicherweise ein neues Verhältnis 
              zur eigenen natürlichen Erscheinung schafft.
            </p>

            <h3>Warum wir das tun</h3>
            <p>
              Studien zeigen, dass viele Menschen ein verzerrtes Bild ihrer eigenen Erscheinung haben, beeinflusst 
              durch ständige Exposition gegenüber bearbeiteten Bildern in Medien und sozialen Netzwerken. Unser Ziel 
              ist es, diese Verzerrung zu korrigieren und Menschen zu helfen, ihr natürliches Aussehen neu zu entdecken.
            </p>
            <p>
              Für manche kann dies bedeuten, mehr Selbstvertrauen ohne Make-up zu gewinnen. Für andere kann es eine 
              Möglichkeit sein, subtilere Make-up-Techniken zu erkunden, die ihre natürlichen Züge ergänzen statt 
              sie zu überdecken.
            </p>

            <h3>Unsere Technologie</h3>
            <p>
              Die Herzstück von NaturalMe ist unsere proprietäre KI-Technologie, die mehrere Jahre Forschung und 
              Entwicklung erforderte. Unsere Algorithmen wurden mit Millionen von Bildern trainiert, um präzise 
              zwischen natürlichen Gesichtszügen und aufgetragenem Make-up zu unterscheiden.
            </p>
            <p>
              Im Gegensatz zu einfachen Filtern, die lediglich Farbänderungen vornehmen, analysiert unsere KI die 
              Struktur des Gesichts, die natürliche Hautbeschaffenheit und individuelle Merkmale, um ein authentisches 
              Bild zu rekonstruieren. Das Ergebnis ist keine generische Version, sondern ein personalisiertes Bild, 
              das zeigt, wie DU ohne Make-up aussehen könntest.
            </p>
          </div>
        </div>
      </div>

      {/* Team section */}
      <div className="bg-white">
        <div className="mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24">
          <div className="space-y-12">
            <h2 className="text-3xl font-extrabold tracking-tight sm:text-4xl text-center">Unser Team</h2>
            <p className="text-lg text-gray-500 max-w-3xl mx-auto text-center">
              Hinter NaturalMe steht ein engagiertes Team aus KI-Spezialisten, Entwicklern und Designern, 
              die alle die Leidenschaft für natürliche Schönheit teilen.
            </p>

            <ul className="space-y-12 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:grid-cols-3 lg:gap-x-8">
              {/* Teammitglied 1 - nur Platzhalter für den Prototyp */}
              <li>
                <div className="space-y-4">
                  <div className="aspect-w-3 aspect-h-2">
                    <div className="h-0 pt-[100%] bg-gray-200 rounded-lg"></div>
                  </div>
                  <div className="space-y-2">
                    <div className="text-lg leading-6 font-medium space-y-1">
                      <h3>Maria Schmidt</h3>
                      <p className="text-primary-600">Gründerin & CEO</p>
                    </div>
                    <div className="text-gray-500">
                      <p className="text-base">
                        Mit Hintergrund in KI und Computer Vision ist Maria die visionäre Kraft hinter NaturalMe.
                      </p>
                    </div>
                  </div>
                </div>
              </li>

              {/* Teammitglied 2 */}
              <li>
                <div className="space-y-4">
                  <div className="aspect-w-3 aspect-h-2">
                    <div className="h-0 pt-[100%] bg-gray-200 rounded-lg"></div>
                  </div>
                  <div className="space-y-2">
                    <div className="text-lg leading-6 font-medium space-y-1">
                      <h3>David Müller</h3>
                      <p className="text-primary-600">Technischer Leiter</p>
                    </div>
                    <div className="text-gray-500">
                      <p className="text-base">
                        David leitet die technische Entwicklung und sorgt dafür, dass unsere KI-Modelle kontinuierlich verbessert werden.
                      </p>
                    </div>
                  </div>
                </div>
              </li>

              {/* Teammitglied 3 */}
              <li>
                <div className="space-y-4">
                  <div className="aspect-w-3 aspect-h-2">
                    <div className="h-0 pt-[100%] bg-gray-200 rounded-lg"></div>
                  </div>
                  <div className="space-y-2">
                    <div className="text-lg leading-6 font-medium space-y-1">
                      <h3>Sophie Weber</h3>
                      <p className="text-primary-600">UX-Designerin</p>
                    </div>
                    <div className="text-gray-500">
                      <p className="text-base">
                        Sophie gestaltet die Benutzererfahrung und achtet darauf, dass NaturalMe intuitiv und zugänglich ist.
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* CTA section */}
      <div className="bg-primary-700">
        <div className="max-w-2xl mx-auto text-center py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
            <span className="block">Entdecke dein natürliches Ich</span>
            <span className="block">Starte noch heute mit NaturalMe</span>
          </h2>
          <p className="mt-4 text-lg leading-6 text-primary-200">
            Probiere unsere Technologie kostenlos aus und erfahre, wie du ohne Make-up aussehen könntest.
          </p>
          <Link
            to="/demo"
            className="mt-8 w-full inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-primary-600 bg-white hover:bg-primary-50 sm:w-auto"
          >
            Kostenlose Demo testen
          </Link>
        </div>
      </div>
    </div>
  );
}